// extracted by mini-css-extract-plugin
export default {"hello":"DashboardLoanHeader_hello","strapline":"DashboardLoanHeader_strapline"};